import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItem: {},
  cartCount: 0,
  isLoaded: false,
  cartIdForBuyNow: "",
  isLoading: true,
};

const cartSlice = createSlice({
  name: "cart",
  initialState: initialState,
  reducers: {
    setCartLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCartData(state, action) {
      state.cartItem = action.payload;
      state.isLoading = false;
    },
    setCartCount(state, action) {
      state.cartCount = action.payload;
      state.isLoaded = true;
    },
    setCartIdForBuyNow(state, action) {
      state.cartIdForBuyNow = action.payload;
    },
  },
});

export const { setCartData, setCartCount, setCartIdForBuyNow, setCartLoading } =
  cartSlice.actions;
export default cartSlice.reducer;
